import React, { Fragment } from "react";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";

import { CalculatedRate } from "./CalculatedValues";

class ReplacementRate extends React.Component {
  render() {
    const { yieldCurveResult } = this.props;

    // Dividing treasury result by 100 since it comes back from the end point as for example 2.8382 instead of 0.028382
    return (
      <CalculatedRate label="Spot Replacement Rate (%) " value={(yieldCurveResult).toFixed(5)} decimalCount={3} />
    );
  }
}

const mapStateToProps = ({ testHarness }) => ({
  yieldCurveResult: _.get(testHarness, "testData.yieldCurveResult", 0)
});

export default compose(
  connect(
    mapStateToProps,
    {}
  )
)(ReplacementRate);
